/* global data, $, query_string */
/* eslint-disable import/no-relative-packages */
import * as d3 from 'd3'
import '../bower_components/tablesorter/jquery.tablesorter.min'
import './tablesorter-widget'

const attackZone = require('bam-node-bdata-charts/chart.attack-zone')

function returnZones(zoneData, inverse = false) {
    const zones = [
        {
            pitches: 0,
            total_pitches: 1,
            api_gameday3_pitchzone_cd: 1,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 2,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 3,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 4,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 5,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 6,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 7,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 8,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 9,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 11,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 12,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 13,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 14,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 16,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 17,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 18,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 19,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 21,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 22,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 23,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 24,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 26,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 27,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 28,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 29,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 31,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 32,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 33,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 34,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 36,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 37,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 38,
        },
        {
            pitches: 0,
            api_gameday3_pitchzone_cd: 39,
        },
    ]

    for (let i = 0; i < zones.length; i++) {
        const zoneNum = zones[i].api_gameday3_pitchzone_cd
        if (zoneNum >= 11 && zoneNum <= 19) {
            if (zoneData[`z_score_${zoneNum}`]) {
                zones[i].zScore = zoneData[`z_score_${zoneNum}`]
            } else {
                zones[i].zScore = 0
            }
        } else {
            zones[i].zScore = 0
        }

        if (inverse) {
            zones[i].zScore *= -1
        }
    }
    return zones
}

function createZoneChart(id, size, zoneData, invert = false) {
    const opts = {
        id,
        svgId: id,
        show_footer: 'false',
        type: 'zScore',
        width: size,
        height: size,
        backgroundColor: '#ddd',
        segmentStrokeWidth: 0,
        segmentStrokeColor: '#888',
        // colorScaleType: attackZoneChart.colorScaleTypes.originalSavantColorScale,
        regions: {
            heart: true,
            shadow: true,
            chase: false,
            waste: false,
        },
        valueTags: false,
        tooltips: false,
        plate: true,
        footerText: '',
        zone_data: returnZones(zoneData, invert),
    }

    attackZone(opts)
}

function removeQualified() {
    if ($('#ddlMin').val() === 'q') {
        $('#ddlMin').val('100')
        $('#lblMin').html(`Min Pitches Called: ${$('#ddlMin').val()}`)
    }

    $('#ddlMin').find('option[value=q]').remove()
}

function addQualified() {
    if ($('#ddlMin').find('option[value=q]').length === 0) {
        $('#ddlMin').prepend("<option value='q'>Qualified</option>")
    }
}

function handleQualifiedOption() {
    const isQualifiedProps = ['catcher', 'pitcher']

    if (
        isQualifiedProps.includes($('#ddlType').val()) &&
        $('#ddlSeason').val() !== '0'
    ) {
        addQualified()
    } else {
        removeQualified()
    }
}

function handleTeamDropdown() {
    const isTeamProps = ['fielding_team', 'batting_team']
    if (isTeamProps.includes($('#ddlType').val())) {
        $('#ddlTeamId').val('')
        $('#ddlTeamId').closest('.form-group').hide()
    } else if ($('#ddlSeason').val() === '0') {
        $('#ddlTeamId').val('')
        $('#ddlTeamId').closest('.form-group').hide()
    } else {
        $('#ddlTeamId').closest('.form-group').show()
    }
}

function createUrl(sort) {
    const url = `/catcher_framing?year=${$('#ddlSeason').val()}&team=${$(
        '#ddlTeamId'
    ).val()}&min=${$('#ddlMin').val()}&type=${$('#ddlType').val()}`

    return sort ? `${url}&sort=${sort}` : url
}

$(document).ready(() => {
    $.tablesorter.addWidget({
        // give the widget a id
        id: 'indexFirstColumn',
        // format is called when the on init and when a sorting has finished
        format(table) {
            // loop all tr elements and set the value for the first column
            for (let i = 0; i < table.tBodies[0].rows.length; i++) {
                const id = table.tBodies[0].rows[i].id.split('_')[1]

                if (id === '999999') {
                    $(`tbody tr:eq(${i}) td:first`, table).html('')
                } else {
                    $(`tbody tr:eq(${i}) td:first`, table).html(i)
                }
            }
        },
    })

    let defaultSort = [[[4, 1]]]
    if (query_string.sort && query_string.sort.indexOf(',') > -1) {
        defaultSort = [[query_string.sort.split(',')]]
    }

    $('#catcher_framing_table')
        .tablesorter({
            widgets: ['staticRow', 'indexFirstColumn'],
            sortInitialOrder: 'desc',
        })
        .trigger('sorton', defaultSort)

    $('form').submit(false)

    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })

    $('#ddlType').on('change', () => {
        $('#lblType').html(`View: ${$('#ddlType option:selected').text()}`)

        handleQualifiedOption()
        handleTeamDropdown()
    })

    $('#catcher_framing_table').on('sortEnd', (event) => {
        const sort = event.target.config.sortList
        const url = createUrl(sort)

        window.history.pushState('', '', url)
    })

    $('#ddlSeason').change(() => {
        handleQualifiedOption()
        handleTeamDropdown()
        $('#lblSeason').html($('#ddlSeason option:selected').text())
    })
    $('#ddlMin').change(() => {
        $('#lblMin').html(`Min Called Pitches: ${$('#ddlMin').val()}`)
    })

    if (query_string.year) {
        if (query_string.year === '0') {
            $('#btnLeagueAvg').hide()
        }
    }

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }

    createZoneChart('zone_11', 50, {
        z_score_11: 3,
        z_score_12: -3,
        z_score_13: -3,
        z_score_14: -3,
        z_score_16: -3,
        z_score_17: -3,
        z_score_18: -3,
        z_score_19: -3,
    })
    createZoneChart('zone_12', 50, {
        z_score_11: -3,
        z_score_12: 3,
        z_score_13: -3,
        z_score_14: -3,
        z_score_16: -3,
        z_score_17: -3,
        z_score_18: -3,
        z_score_19: -3,
    })
    createZoneChart('zone_13', 50, {
        z_score_11: -3,
        z_score_12: -3,
        z_score_13: 3,
        z_score_14: -3,
        z_score_16: -3,
        z_score_17: -3,
        z_score_18: -3,
        z_score_19: -3,
    })
    createZoneChart('zone_14', 50, {
        z_score_11: -3,
        z_score_12: -3,
        z_score_13: -3,
        z_score_14: 3,
        z_score_16: -3,
        z_score_17: -3,
        z_score_18: -3,
        z_score_19: -3,
    })
    createZoneChart('zone_16', 50, {
        z_score_11: -3,
        z_score_12: -3,
        z_score_13: -3,
        z_score_14: -3,
        z_score_16: 3,
        z_score_17: -3,
        z_score_18: -3,
        z_score_19: -3,
    })
    createZoneChart('zone_17', 50, {
        z_score_11: -3,
        z_score_12: -3,
        z_score_13: -3,
        z_score_14: -3,
        z_score_16: -3,
        z_score_17: 3,
        z_score_18: -3,
        z_score_19: -3,
    })
    createZoneChart('zone_18', 50, {
        z_score_11: -3,
        z_score_12: -3,
        z_score_13: -3,
        z_score_14: -3,
        z_score_16: -3,
        z_score_17: -3,
        z_score_18: 3,
        z_score_19: -3,
    })
    createZoneChart('zone_19', 50, {
        z_score_11: -3,
        z_score_12: -3,
        z_score_13: -3,
        z_score_14: -3,
        z_score_16: -3,
        z_score_17: -3,
        z_score_18: -3,
        z_score_19: 3,
    })

    const isDefenseProps = ['catcher', 'pitcher', 'fielding_team']
    const standardColoring =
        isDefenseProps.includes(query_string.type) || !query_string.type
    for (let i = 0; i < data.length; i++) {
        const zoneData = data[i]
        createZoneChart(
            `attack_${zoneData.key_entity_id}`,
            75,
            zoneData,
            !standardColoring
        )
    }

    $('.zone').hover(
        function zoneIn() {
            const catcher = this.id.split('_')[2]
            const zone = this.id.split('_')[1]
            const svg = d3.select(`#attack_${catcher}`)
            svg.selectAll(`.segmentZone_${zone}`).classed(
                'highlight-zone',
                true
            )
        },
        function zoneOut() {
            const zone = this.id.split('_')[1]
            d3.selectAll(`.segmentZone_${zone}`).classed(
                'highlight-zone',
                false
            )
        }
    )

    $('#btnLeagueAvg').click(() => {
        $('#framing-tr_999999').toggle()
    })

    let hidden = true
    document.getElementById('btnStrikeZone').addEventListener('click', () => {
        hidden = !hidden
        document.querySelectorAll('[data-strike-zone-viz]').forEach((el) => {
            el.style.setProperty('display', hidden ? 'none' : 'block')
        })
    })

    $('#btnUpdate').on('click', () => {
        window.location.href = createUrl()
    })

    $('#btnCSV').click(() => {
        const url = `${createUrl()}&csv=true`
        window.location.href = url
    })

    // #lazy:  Do these last, since other things might mess with select values
    handleQualifiedOption()
    handleTeamDropdown()
})
